document.addEventListener("DOMContentLoaded", () => {
    /*document.querySelector(".main-menu-mobile-wrapper").addEventListener("click", () => {
        document.querySelector(".main-menu-mobile-wrapper").classList.remove("open");
    });*/

    /*document.querySelector(".main-menu-mobile-wrapper a").addEventListener("click", (e) => {
        e.stopPropagation();
    });*/

    /*document.querySelectorAll(".menu-button, .menu-button-mobile").forEach(element => {
        element.addEventListener("click", () => {
            document.querySelector(".main-menu-mobile-wrapper").classList.add("open");
        });
    });*/

    // Bugfix for rendering the buttons
    document.querySelectorAll(".has-karsten-wtf-gradient-color.has-light-darker-background-color").forEach((element) => {
        element.parentElement.classList.add("has-light-darker-background-color");
        element.classList.remove("has-light-darker-background-color");
        element.parentElement.style.borderRadius = element.style.borderRadius;
    });

    document.querySelectorAll(".insert-mailto a").forEach(element => {
        element.href = "mailto:kontakt" + "@" + "karsten.wtf";
    });

    document.querySelectorAll(".set-aria-hidden").forEach(element => {
        element.setAttribute("aria-hidden", "true");
    }); 

    // If WordPress sets the gradient-color-class to an element with child-elements, we move the class to the child
    // This is a workaround because background-clip:text doesnt work well on safari when nested
    document.querySelectorAll(".has-karsten-wtf-gradient-color").forEach((element) => {
        if(element.querySelectorAll("p").length > 0){
            element.classList.remove("has-karsten-wtf-gradient-color");
            element.querySelectorAll("p").forEach((element2) => {
                element2.classList.add("has-karsten-wtf-gradient-color");
            });
        }
    });
});